import { Modal } from 'react-bootstrap';
import { LuX } from 'react-icons/lu';

import ResourcesPodcastPlayer from './ResourcesPodcastPlayer';
import SbrIcon from './SbrIcon';
import { parseYouTubeVideoId } from '../../lib/youtube';

type Props = {
  show: boolean;
  onHide: () => void;
  videoUrl: string;
  title?: string;
};

export default function ProductVideoModal({
  show,
  onHide,
  videoUrl,
  title = 'SBR2TH.ai product demo',
}: Props) {
  const videoId = parseYouTubeVideoId(videoUrl);

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="lg"
      className="product-video-modal"
      contentClassName="product-video-modal__content"
    >
      <button
        type="button"
        className="product-video-modal__close"
        aria-label="Close video"
        onClick={onHide}
      >
        <SbrIcon icon={LuX} size={18} />
      </button>
      <Modal.Body className="product-video-modal__body p-0">
        {videoId ? (
          <ResourcesPodcastPlayer videoId={videoId} title={title} autoplay />
        ) : (
          <p className="text-center text-muted py-5 mb-0 px-3">
            Video is unavailable. Please set <code>REACT_APP_PRODUCT_VIDEO_URL</code> in your environment.
          </p>
        )}
      </Modal.Body>
    </Modal>
  );
}
